<div class="filter">
  <div class="spen-ly-modal spen-ly-static" id="modal">
    <div class="modal-dialog">
      <div class="inner">
        <div class="modal-heading">
          <span class="top-btn-close" (click)="onBack('close-modal')">
            <i class="fa fa-times"></i>
          </span>
          <h2 class="heading-text">活動記録参照</h2>
        </div>
        @if (dataLoaded()) {
          <div class="modal-content">
            @if (isDocumentRecord()) {
              <div class="segments">
                <app-segment-view [tabOptions]="tabOptions" (switchTab)="switchTab($event)"></app-segment-view>
              </div>
            }
            @if (isQuestionnaireRecord()) {
              <div class="text-info">
                <p>作成日時: {{ activityRecord.created_at | date: 'yyyy/MM/dd HH:mm' }}</p>
                <p>［アンケート］</p>
              </div>
              <app-questionnaire-detail-student [questionnaire]="activityRecord.record"></app-questionnaire-detail-student>
            }
            @if (isDocumentRecord()) {
              @switch (currentTab) {
                @case ('self') {
                  <div class="text-info">
                    <p>作成日時: {{ activityRecord.created_at | date: 'yyyy/MM/dd HH:mm' }}</p>
                    @if (activityRecord.is_answer) {
                      <p>［課題］</p>
                    }
                  </div>
                  <app-document-detail-student
                    [document]="activityRecord?.record"
                    [categoryName]="categoryName"
                    [marks]="activityRecord?.marks"
                    [document_answers]="activityRecord.record.document_answers"
                    [isCompassAnswer]="activityRecord?.is_compass_answer"
                  >
                  </app-document-detail-student>
                  @if (activityRecord.space_name) {
                    <div class="space-album-name">提出先：{{ activityRecord.space_name }}</div>
                  }
                }
                @case ('cross_assessment') {
                  <app-student-cross-assessments [crossAssessments]="activityRecord.cross_assessments"> </app-student-cross-assessments>
                }
                @case ('teacher_assessment') {
                  <h2 class="assessments-header">先生からのコメント</h2>
                  @for (assessment of activityRecord.assessments; track assessment.id; let isFirst = $first) {
                    <app-student-assessment-detail [assessment]="assessment" [canEdit]="false" [isFirst]="isFirst">
                    </app-student-assessment-detail>
                  }
                }
              }
            }
            <div class="block-last">
              <button class="spen-mod-btn" (click)="onBack('back')">戻る</button>
            </div>
          </div>
        } @else {
          <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
        }
      </div>
    </div>
  </div>
</div>
